import {
  Box,
  Container,
  Divider,
  Flex,
  Heading,
  Icon,
  List,
  ListIcon,
  ListItem,
  Text,
} from '@chakra-ui/layout';
import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons';

import React from 'react';
import { generate } from 'shortid';

const usVsAgentContent = [
  [
    'No commissions/fees',
    '6% of commissions/fees on average is paid by you, the seller',
  ],
  [
    'closing costs negotiated between buyer and seller',
    '2% of closing cost on average is paid by you, the seller',
  ],
  [
    'No inspection & financing contingency*',
    'Up to 15% of sales fall through due to inspection & financing contingency',
  ],
  [
    'No appraisal needed - we make cash offers',
    'sale is often subject to appraisal',
  ],
  [
    'Immediate cash offer',
    'It can take upto 91 days for finances to become available',
  ],
  ['One showing', 'Many showings looking for a buyer'],
  [
    'Closing date of your choice',
    'Closing dates are normally 30-60 days after accepting buyer offer',
  ],
  ['No repairs', 'Payment of repairs negotiated during inspection period'],
];

const UsVsAgent = () => (
  <Box
    backgroundColor="brand.five"
    py={10}
  >
    <Container maxW="container.xl">
      <Box mb={10}>
        <Heading
          as="h4"
          size="3xl"
        >
          Selling with Us vs Real Estate Agents
        </Heading>
        <Heading
          as="h5"
          size="lg"
          variant="sec"
        >
          Don't take our word for it, check the numbers.
        </Heading>
      </Box>
      <List fontSize="xl">
        {usVsAgentContent.map((item, i) => (
          <Box
            py={4}
            px={2}
            backgroundColor={i % 2 ? 'brand.five' : 'gray.200'}
            display="flex"
            alignItems="center"
            key={generate()}
            flexWrap="wrap"
            justifyContent="space-between"
          >
            <ListItem flexBasis={{ base: '100%', md: '50%' }}>
              <ListIcon
                as={CheckCircleIcon}
                color="green.200"
              />
              {item[0]}
            </ListItem>
            <Divider orientation={{ base: 'horizontal', md: 'vertical' }} />
            <Box flexBasis={{ base: '100%', md: '50%' }}>
              <ListIcon
                as={WarningIcon}
                color="red.200"
              />
              {item[1]}
            </Box>
          </Box>
        ))}
      </List>
    </Container>
  </Box>
);

export default UsVsAgent;
